export default "__VITE_ASSET__51eeaacf__"